var icon = require('vue-svgicon')
icon.register({
  'ks-icon-shield': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M79.68 33.26a72.22 72.22 0 0 1-15.31-11.92 72.21 72.21 0 0 1-15.31 11.92 33.82 33.82 0 0 1-17.56 4.25v40.77c0 4.85 8.22 13.55 16.44 19.34a75.18 75.18 0 0 0 16.44 8.66s8.22-4.58 16.44-10.37 16.43-12.78 16.43-17.63V37.51a33.83 33.83 0 0 1-17.57-4.25zm14.08 44.47l-18.29-6.07-11.22 15.65v-50.2l11.23 15.66 18.28-6.07-11.43 15.51z"/>'
  }
})
